const applyFormula = (formula, nGainMoney, nValue, qGainMoney, qValue) =>
  formula
    .replace(/NOW_GAIN/g, nGainMoney)
    .replace(/NOW_VALUE/g, nValue)
    .replace(/COMMITMENT_GAIN/g, qGainMoney)
    .replace(/COMMITMENT_VALUE/g, qValue);

const calculateGains = (commitmentDefinition, answer) => {
  const { numberOfBeneficiaries } = answer;
  let qValue = null;
  let qGainCo2 = null;
  let qGainEur = null;
  let qGainGbp = null;
  let nValue = null;
  let nGainCo2 = null;
  let nGainEur = null;
  let nGainGbp = null;

  if (!commitmentDefinition) {
    return {
      eurFor1Month: 0,
      gbpFor1Month: 0,
      co2For1Month: 0,
      eurFor1Year: 0,
      gbpFor1Year: 0,
      co2For1Year: 0
    };
  }

  if (commitmentDefinition.answerType === 'number') {
    qGainCo2 = parseFloat(commitmentDefinition.qNumber[0].co2 || null, 10);
    qGainEur = parseFloat(commitmentDefinition.qNumber[0].euros || null, 10);
    qGainGbp = parseFloat(commitmentDefinition.qNumber[0].pounds || null, 10);
    qValue = parseFloat(answer.commitment.value, 10);
  } else {
    const answerId = answer.commitment.value;
    const userChoice = commitmentDefinition.qChoice.find(
      ch => ch.id === answerId
    );
    // console.log('CHOICE', userChoice);
    qGainCo2 = userChoice ? parseFloat(userChoice.co2, 10) : null;
    qGainEur = userChoice ? parseFloat(userChoice.euros, 10) : null;
    qGainGbp = userChoice ? parseFloat(userChoice.pounds, 10) : null;
  }

  if (answer.now) {
    if (commitmentDefinition.nowType === 'number') {
      nGainCo2 = parseFloat(commitmentDefinition.qNowNumber[0].co2 || null, 10);
      nGainEur = parseFloat(
        commitmentDefinition.qNowNumber[0].euros || null,
        10
      );
      nGainGbp = parseFloat(
        commitmentDefinition.qNowNumber[0].pounds || null,
        10
      );
      nValue = answer.now.value;
    } else if (commitmentDefinition.nowType === 'choice') {
      const answerId = answer.now.value;
      // console.log('c def', commitmentDefinition);
      // console.log('answer id', answerId);
      const userChoice = commitmentDefinition.qNowChoice.find(
        ch => ch.id === answerId
      );
      // console.log('CHOICE', userChoice);
      nGainCo2 = userChoice ? parseFloat(userChoice.co2, 10) : null;
      nGainEur = userChoice ? parseFloat(userChoice.euros, 10) : null;
      nGainGbp = userChoice ? parseFloat(userChoice.pounds, 10) : null;
    }
  } else {
    nGainCo2 = null;
    nGainEur = null;
    nGainGbp = null;
    nValue = null;
  }

  // console.log(commitmentDefinition.formulaMoney, qGainCo2, qGainEur, qGainGbp, qValue, nGainCo2, nGainEur, nGainGbp, nValue);

  const formulaEur = applyFormula(
    commitmentDefinition.formulaMoney,
    nGainEur,
    nValue,
    qGainEur,
    qValue
  );

  // console.log('formula eur', commitmentDefinition.formulaMoney, formulaEur);

  const formulaGbp = applyFormula(
    commitmentDefinition.formulaMoney,
    nGainGbp,
    nValue,
    qGainGbp,
    qValue
  );
  const formulaCo2 = applyFormula(
    commitmentDefinition.formulaCo2,
    nGainCo2,
    nValue,
    qGainCo2,
    qValue
  );

  // Math.round(formulaEurFor1Week * numberOfBeneficiaries * 4 * 1e1, / 1e1);
  /*eslint no-eval: 0*/
  const eurFor1Month = eval(formulaEur) * numberOfBeneficiaries * 4;
  const gbpFor1Month = eval(formulaGbp) * numberOfBeneficiaries * 4;
  const co2For1Month = eval(formulaCo2) * numberOfBeneficiaries * 4;
  const eurFor1Year = eval(formulaEur) * numberOfBeneficiaries * 52;
  const gbpFor1Year = eval(formulaGbp) * numberOfBeneficiaries * 52;
  const co2For1Year = eval(formulaCo2) * numberOfBeneficiaries * 52;

  // console.log({
  //   eurFor1Month,
  //   gbpFor1Month,
  //   co2For1Month,
  //   eurFor1Year,
  //   gbpFor1Year,
  //   co2For1Year,
  // });

  return {
    eurFor1Month,
    gbpFor1Month,
    co2For1Month,
    eurFor1Year,
    gbpFor1Year,
    co2For1Year
  };
};

export const formatGain = (gain, lang, intlOptions, convert = false) => {

  if (!lang) return;
  
  let newGain = Number(gain);

  let langIntl = '';

  if (lang && lang.match(/^[a-z]{2}$/)) {
    if (lang === 'fr') {
      langIntl = 'fr-FR';
    } else {
      langIntl = 'en-GB';
    }
  }

  if (convert && newGain > 1000000) {
    newGain /= 1000000;
  } else if (convert && newGain > 1000) {
    newGain /= 1000;
  }

  return new Intl.NumberFormat(langIntl, intlOptions).format(newGain);
};

export const determineUnitAfterConversion = (gain) => {
  let unit = 'g';

  if (gain > 1000000) {
    unit = 'T';
  } else if (gain > 1000) {
    unit = 'KG'
  }

  return unit;
}

export default calculateGains;
